module.exports = __webpack_public_path__ + "img/panelView_defaultBG_special_strong.4ba8c400.png";